// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Credits_root__WrMeI {
  padding: 15px 40px 90px 40px;
  height: calc(100vh - 188px);
  overflow-y: scroll;
  overflow: scroll;
  margin-right: auto;
  margin-left: auto;
  color: var(--color-font-10);
  font-size: 16px !important;
}

.Credits_account_title__f-cGi {
  display: flex;
  align-items: center;
}

.Credits_business_icon__-GNBb {
  padding-right: 10px;
}

.Credits_arrow_icon__oGobU {
  padding: 0px 20px;
  color: var(--color-theme-silver);
}

.Credits_account_title__f-cGi {
  display: flex;
  align-items: center;
}

.Credits_business_icon__-GNBb {
  padding-right: 10px;
}

.Credits_credits_container__7txKd {
  margin: 15px;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/Credits/Credits.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".root {\n  padding: 15px 40px 90px 40px;\n  height: calc(100vh - 188px);\n  overflow-y: scroll;\n  overflow: scroll;\n  margin-right: auto;\n  margin-left: auto;\n  color: var(--color-font-10);\n  font-size: 16px !important;\n}\n\n.account_title {\n  display: flex;\n  align-items: center;\n}\n\n.business_icon {\n  padding-right: 10px;\n}\n\n.arrow_icon {\n  padding: 0px 20px;\n  color: var(--color-theme-silver);\n}\n\n.account_title {\n  display: flex;\n  align-items: center;\n}\n\n.business_icon {\n  padding-right: 10px;\n}\n\n.credits_container {\n  margin: 15px;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Credits_root__WrMeI`,
	"account_title": `Credits_account_title__f-cGi`,
	"business_icon": `Credits_business_icon__-GNBb`,
	"arrow_icon": `Credits_arrow_icon__oGobU`,
	"credits_container": `Credits_credits_container__7txKd`
};
export default ___CSS_LOADER_EXPORT___;
